<template>
  <div class="container">
    <div v-if="isAdmin" class="app__nav-wrapper">
      <b-navbar toggleable="lg" class="app__main-nav">
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item
              aaav-if="user.hasPermission('eventList')"
              to="/certification"
            >
              Lista wydarzeń
            </b-nav-item>
            <b-nav-item aaav-if="user.hasPermission('eventNew')" to="/accounts">
              Konta użytkowników
            </b-nav-item>

            <b-nav-item
              aaav-if="user.hasPermission('eventNew')"
              to="/organizations"
            >
              Organizacje
            </b-nav-item>

            <b-nav-item
              aaav-if="user.hasPermission('eventNew')"
              to="/locations"
            >
              Lokalizacje
            </b-nav-item>

            <b-nav-item aaav-if="user.hasPermission('eventNew')" to="/stats">
              Statystyki
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>

        <img src="/polmed-logo-small.png" class="app__nav-logo" />
        <img src="/medtech-logo-small.png" class="app__nav-logo" />
      </b-navbar>
    </div>
  </div>
</template>

<script>
import PageNav from "./PageNav";

export default {
  name: "AdminNav",
  extends: PageNav
};
</script>
